import Action from '../_Action';

export default class SetRouterPageLoading extends Action {
  /** The action namespace */
  static namespace = 'Core/Router';

  static type = 'Core/Router/SetRouterPageLoading';

  loadingPage: number;

  constructor(loadingPage: number) {
    super();
    this.type = `${(this.constructor as typeof SetRouterPageLoading).type}`;
    this.loadingPage = loadingPage;
  }
}
